<template>
  <div>
    <h1>commodityRestriction page</h1>
  </div>
</template>

<script>
export default {
  data () {
    return {

    };
  }
};
</script>

<style lang="less" scoped>

</style>
